import { LayoutContext } from 'contexts/layoutContext/LayoutContext';
import { RegistroContext } from 'contexts/registroContext/RegistroContext';
import { Ferramenta } from 'enum';
import {
  Checkbox,
  Col,
  Collapse,
  Input,
  Row,
  Select,
  ToastTypes,
} from 'plataforma-fundacao-componentes';
import { useCallback, useContext, useMemo } from 'react';
import { languageValues } from 'utils/LanguageUtils';
import styles from './NaoAssociado.scss';
import EventoSistemicoForm from './eventoSistemicoForm/EventoSistemicoForm';
import { objectToSelectOptions } from 'utils/InputUtils';

const { rootClassName } = styles;

const texts = languageValues.pages.naoAssociado;
interface Props {
  opened: boolean;
  isSistemico?: boolean;
}

export default function NaoAssociado({ opened, isSistemico }: Props) {
  const { showToast } = useContext(LayoutContext);

  const { state, dispatch } = useContext(RegistroContext);

  const agencias = useMemo(
    () =>
      state.evento?.agencias.map((a) =>
        objectToSelectOptions(a.codAgencia, a.nomeAgencia)
      ) ?? [],
    [state.evento]
  );

  const selecionarAgencia = useCallback(
    (value?: string) =>
      dispatch({
        type: 'setDadosNaoAssociado',
        payload: { agencia: value },
      }),
    [dispatch]
  );

  const selecionarCooperativa = useCallback(
    (value?: string) =>
      dispatch({
        type: 'setDadosNaoAssociado',
        payload: { cooperativa: value },
      }),
    [dispatch]
  );

  return (
    <Collapse animateOpacity opened={opened}>
      <Row>
        <Col>
          <Input
            label={texts.input.nome.label}
            placeholder={texts.input.nome.placeholder}
            value={state.dadosNaoAssociado?.nome}
            onChange={(e) =>
              dispatch({
                type: 'setDadosNaoAssociado',
                payload: { nome: e.target.value },
              })
            }
            maxLength={100}
          />
        </Col>
      </Row>

      <Collapse animateOpacity opened={!isSistemico && agencias.length > 1}>
        <Row>
          <Col>
            <Select
              label={texts.input.agencia.label}
              placeholder={texts.input.agencia.placeholder}
              panelFilter
              options={agencias}
              onChange={selecionarAgencia}
              value={state.dadosNaoAssociado?.agencia}
            />
          </Col>
        </Row>
      </Collapse>

      <Collapse animateOpacity opened={isSistemico}>
        <EventoSistemicoForm
          selecionarAgencia={selecionarAgencia}
          selecionarCooperativa={selecionarCooperativa}
        />
      </Collapse>

      <Row>
        <Col className={`${rootClassName}-check`}>
          <div className='checkbox'>
            <Checkbox
              value={state.dadosNaoAssociado?.checkTermo}
              onChange={(val, evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                if (!val) {
                  showToast({
                    label: texts.termoCrescer.erro,
                    theme: ToastTypes.Error,
                    timeout: 10000,
                    showStatusBar: true,
                  });
                }
                dispatch({
                  type: 'setDadosNaoAssociado',
                  payload: { checkTermo: val },
                });
              }}
            />
          </div>
          <p>
            {state.ferramenta === Ferramenta.CRESCER
              ? texts.termoCrescer.texto
              : texts.termo.texto}
          </p>
        </Col>
      </Row>
    </Collapse>
  );
}
